// Shared metadata for the public page and build-time HTML.
module.exports = {
  path: '/services/rag-implementation',
  title: 'RAG Implementation Services for Internal Knowledge | DataBackfill',
  description: 'Plan and build a RAG knowledge system with DataBackfill. Scope source data, document permissions, retrieval evaluation, operating costs, and handover.',
};
